import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable()
export class CustomIconsService {

  constructor(
    private readonly matIconRegistry: MatIconRegistry,
    private readonly domSanitizer: DomSanitizer,
  ) {

  }

  initialize() {
    const getResource = this.domSanitizer.bypassSecurityTrustResourceUrl;
    this.matIconRegistry.addSvgIcon('distance-crt', getResource('../../../assets/svg/distance.crt.svg'));
    this.matIconRegistry.addSvgIcon('delivery-car-crt', getResource('../../../assets/svg/delivery-car.crt.svg'));
    this.matIconRegistry.addSvgIcon('profit-crt', getResource('../../../assets/svg/profit.crt.svg'));
    this.matIconRegistry.addSvgIcon('service-fee-crt', getResource('../../../assets/svg/fee.crt.svg'));
    this.matIconRegistry.addSvgIcon('price-crt', getResource('../../../assets/svg/price.crt.svg'));
    this.matIconRegistry.addSvgIcon('order-status-crt', getResource('../../../assets/svg/order-status.crt.svg'));
  }
}
